import { Informations, InformationSectionFour, Pricing } from '../../components';
import { homeObjectOne, homeObjectThree } from './Data';

function Services() {
  return (
    <>
      <Pricing />
      <Informations {...homeObjectOne} />
      <InformationSectionFour {...homeObjectThree} />
    </>
  );
}

export default Services;
